// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__25TpO","disabled":"FileBtn_disabled__303Ix","warn":"FileBtn_warn__3h_gQ","fade":"FileBtn_fade__DJ_qJ"};